import { isNil } from 'lodash-es'
import useWebhookEditable from 'components/business/Integration/hooks/useWebhookEditable'
import { useWebhookBuilderFormContext } from '../formContext'

export default function useIsBuilderEditable() {
  const form = useWebhookBuilderFormContext()
  return useWebhookEditable() || isNil(form.values.id)
}
